import api from './api';

export const invoiceService = {
  async getInvoices(params = {}) {
    try {
      const queryParams = {
        limit: params.limit || 50,
        offset: params.offset || 0
      };

      // Dodaj location_id jeśli jest dostępne
      if (params.location_id) {
        queryParams.location_id = params.location_id;
      }

      const response = await api.get('/purchase-invoices', { params: queryParams });
      return response.data;
    } catch (error) {
      console.error('Błąd pobierania faktur:', error);
      throw error;
    }
  },

  async searchInvoices(searchParams = {}) {
    try {
      // Backend: GET /api/purchase-invoices accepts search, date_from, date_to, supplier, status, page, per_page
      const queryParams = {};
      if (searchParams.query) queryParams.search = searchParams.query;
      if (searchParams.date_from) queryParams.date_from = searchParams.date_from;
      if (searchParams.date_to) queryParams.date_to = searchParams.date_to;
      if (searchParams.supplier) queryParams.supplier = searchParams.supplier;
      if (searchParams.status) queryParams.status = searchParams.status;
      if (searchParams.limit) queryParams.per_page = searchParams.limit;
      if (searchParams.location_id) queryParams.location_id = searchParams.location_id;

      const response = await api.get('/purchase-invoices', { params: queryParams });
      return response.data;
    } catch (error) {
      console.error('Błąd wyszukiwania faktur:', error);
      throw error;
    }
  },

  async getInvoiceDetails(invoiceId) {
    try {
      const response = await api.get(`/purchase-invoices/${invoiceId}`);
      return response.data;
    } catch (error) {
      console.error('Błąd pobierania szczegółów faktury:', error);
      throw error;
    }
  },

  async createInvoice(invoiceData) {
    try {
      const response = await api.post('/purchase-invoices', invoiceData);
      return response.data;
    } catch (error) {
      console.error('Błąd tworzenia faktury:', error);
      throw error;
    }
  },

  async deleteInvoice(invoiceId) {
    try {
      const response = await api.delete(`/purchase-invoices/${invoiceId}`);
      return response.data;
    } catch (error) {
      console.error('Błąd usuwania faktury:', error);
      throw error;
    }
  },

  async getInvoiceStats() {
    try {
      const response = await api.get('/purchase-invoices/menu');
      return response.data;
    } catch (error) {
      console.error('Błąd pobierania statystyk faktur:', error);
      throw error;
    }
  },

  async getSuppliers() {
    try {
      // Backend: GET /api/purchase-invoices/reports/top-suppliers returns supplier list grouped by name/NIP
      const response = await api.get('/purchase-invoices/reports/top-suppliers', {
        params: { limit: 100 }
      });
      return response.data;
    } catch (error) {
      console.error('Błąd pobierania dostawców:', error);
      throw error;
    }
  },

  async getRecentInvoices(limit = 10) {
    try {
      // Backend: GET /api/purchase-invoices returns invoices sorted by date DESC (newest first)
      // Use per_page to limit results instead of a separate /recent endpoint
      const response = await api.get('/purchase-invoices', {
        params: { per_page: limit, page: 1 }
      });
      return response.data;
    } catch (error) {
      console.error('Błąd pobierania ostatnich faktur:', error);
      throw error;
    }
  }
};
